import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType, DemurrageCalculationRoundingRule } from "__generated__/graphql";
import DemurrageCalculationCalculationMethodForm from "../components/form/DemurrageCalculationCalculationMethodForm";
import DemurrageCalculationCalculationMethodDetails from "../components/details/DemurrageCalculationCalculationMethodDetails";

export const DemurrageCalculationSchema: RegistryItem = {
	[CalculationMethodType.DemurrageCalculation]: {
		Form: DemurrageCalculationCalculationMethodForm,
		Details: DemurrageCalculationCalculationMethodDetails,
		fields: {
			"calculationMethod.laytimeAllowed": {
				path: "laytimeAllowed",
				rules: {
					required: true,
				},
			},
			"calculationMethod.laytimeRoundingUnit": {
				path: "laytimeRoundingUnit",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.laytimeRoundingRule !== DemurrageCalculationRoundingRule.None,
				},
			},
			"calculationMethod.laytimeRoundingScope": {
				path: "laytimeRoundingScope",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.laytimeRoundingRule !== DemurrageCalculationRoundingRule.None,
				},
			},
			"calculationMethod.price": {
				path: "price",
				rules: {
					required: true,
				},
			},
			"calculationMethod.demurrageCalculationUnit": {
				path: "demurrageCalculationUnit",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			demurrageCalculationCalculationMethodInput: {
				id: form.id ?? undefined,
				laytimeRoundingRule: form.laytimeRoundingRule ?? undefined,
				laytimeRoundingUnit: form.laytimeRoundingUnit ?? undefined,
				laytimeRoundingScope: form.laytimeRoundingScope ?? undefined,
				laytimePeriodRegime: form.laytimePeriodRegime ?? undefined,
				demurrageCalculationUnit: form.demurrageCalculationUnit ?? undefined,
				laytimeAllowed: form.laytimeAllowed !== undefined && form.laytimeAllowed !== null ? Math.round(form.laytimeAllowed * 60) : undefined, // to minutes,
				price: form.price ?? undefined,
				description: form.description ?? undefined, // instructions
				defaultCargoActionTypes: form.defaultCargoActionTypes ?? [],
			},
		}),
		toForm: (method) => ({
			demurrageCalculationUnit: method.demurrageCalculationUnit ?? undefined,
			laytimeRoundingRule: method.laytimeRoundingRule ?? undefined,
			laytimeRoundingUnit: method.laytimeRoundingUnit ?? undefined,
			laytimeRoundingScope: method.laytimeRoundingScope ?? undefined,
			laytimePeriodRegime: method.laytimePeriodRegime ?? undefined,
			laytimeAllowed: (method.laytimeAllowed !== undefined) ? (method.laytimeAllowed ?? 0) / 60 : undefined,
			defaultCargoActionTypes: method.defaultCargoActionTypes ?? [],
		}),
	},
};
